import React, {Component} from "react";
import Section from "./layouts/Section";
import {Link} from "react-router-dom";

class Consulting extends Component {
    render() {
        return (
            <Section title={'Consultation'}>
                <section className="section page-content">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="row">
                                    <div className="col-md-6">
                                        <img className="img-fluid shadow" src={process.env.PUBLIC_URL + '/assets/images/consultation.jpg'} alt="" />
                                    </div>
                                    <div className="col-md-6 mt-4 mt-md-0">
                                        <h2 className="h1 text-dark mb-25">Got a Question For Us?</h2>
                                        <p>We're here to help! Even if you don't have device for us to fix,
                                            we are always here to take care of your IT needs. Want to become
                                            more proficient with your tech? 
                                            Want to have something installed at home but don't know where to start?
                                            Got a project for us?
                                        </p>
                                        <p>Schedule a consultation with us today, and we'll see what we can do for you!</p>
                                        
                                    </div>  
                                </div>
                               {/* <div className="row mt-70">
                                    <div className="col-md-6">
                                        <h3 className="text-dark mb-25">Repair Details</h3>
                                        <p>It sportsman earnestly ye preserved an on. Moment led family sooner cannot
                                            her window pulled any. Or raillery if improved landlord to speaking hastened
                                            differed he. Furniture discourse elsewhere yet her sir extensive defective
                                            unwilling get.</p>
                                        <p className="mt-20">Why resolution one motionless you. Noise is round to in it
                                            quick timed doors. Written address greatly get attacks inhabit pursuit our
                                            but. Want four we face an he gate.</p>
                                    </div>
                                    <div className="col-md-6 mt-4 mt-md-0">
                                        <img className="img-fluid shadow" src={process.env.PUBLIC_URL + '/assets/images/service/02.jpg'} alt="" />
                                    </div>
                                </div> */}
                            </div> 
                            <div className="col-lg-4 mt-5 mt-lg-0">
                                <div className="widget widget-search mt-0">
                                    <form className="d-flex">
                                        <input type="search" className="form-control border-0 shadow-none bg-transparent" placeholder="Search" />
                                        <button type="submit" className="border-0 bg-transparent"><span className="fas fa-search" /></button>
                                    </form>
                                </div>
                                <div className="widget widget-category">
                                    <div className="widget-heading">Category</div>
                                    <ul className="category-list list-unstyled p-4">
                                        <li><span className="fas fa-caret-right mr-2" /><Link to={'/pc-laptop-repair'} className="text-reset initiate-scripts">PC/Laptop Repair</Link></li>
                                        <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/mobile-repair'} className="text-reset initiate-scripts">Mobile Device Repair</Link></li>
                                        <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/game-repair'} className="text-reset initiate-scripts">Game Console Repair</Link></li>
                                        <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/monitoring'} className="text-reset initiate-scripts">Monitoring Solutions</Link></li>
                                        <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/consulting'} className="text-reset initiate-scripts">Consultations</Link></li>
                                    </ul>
                                </div>
                                {/*<div className="widget widget-category">
                                    <div className="widget-heading">Latest Product</div>
                                    <div className="card border-0 product-item shadow mt-20">
                                        <img className="card-img-top border-bottom" src={process.env.PUBLIC_URL + '/assets/images/products/01.jpg'} alt="" />
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <small className="text-uppercase font-w-600">computer products</small>
                                                <div className="rating small text-primary d-flex">
                                                    <span className="fas fa-star" />
                                                    <span className="fas fa-star" />
                                                    <span className="fas fa-star" />
                                                    <span className="fas fa-star" />
                                                    <span className="fas fa-star" />
                                                </div>
                                            </div>
                                            <h5 className="text-dark font-w-600 mt-10 mb-10">Our Recent Products</h5>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <h5 className="font-w-700 text-dark font-secondery">$245.00</h5>
                                                <Link to={'/cart'} className="text-primary font-w-600 text-uppercase initiate-scripts">Add to cart +</Link>
                                            </div>
                                        </div>
                                    </div>
                                    
                                   <div className="card border-0 product-item shadow mt-30">
                                        <img className="card-img-top border-bottom" src={process.env.PUBLIC_URL + '/assets/images/products/02.jpg'} alt="" />
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <small className="text-uppercase font-w-600">Laptop products</small>
                                                <div className="rating small text-primary d-flex">
                                                    <span className="fas fa-star" />
                                                    <span className="fas fa-star" />
                                                    <span className="fas fa-star" />
                                                    <span className="fas fa-star" />
                                                    <span className="fas fa-star" />
                                                </div>
                                            </div>
                                            <h5 className="text-dark font-w-600 mt-10 mb-10">Our Recent Products</h5>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <h5 className="font-w-700 text-dark font-secondery">$245.00</h5>
                                                <Link to={'/cart'} className="text-primary font-w-600 text-uppercase initiate-scripts">Add to cart +</Link>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>*/}
                            </div>
                        </div>
                    </div>
                </section>
            </Section>
        );
    }
}

export default Consulting;